import Head from 'next/head'
import Script from 'next/script'
import { Faq } from '../../components/commons/Faq';
import { acSingaporeFaqs } from '../../utils/faq';

export default function Home(props) {
  
  return (
    <>
      <Head>
        <title>Aircon Service FAQs StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Frequently asked questions related to aircon servicing in Singapore"/>
        <meta name="keywords" content="Frequently asked questions by service providers"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/faq/aircon-service-stringssg" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="Aircon Service FAQs StringsSG"/>
        <meta property="og:description" content="Frequently asked questions related to aircon servicing in Singapore" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/faq/aircon-service-stringssg"/>
        <meta name="twitter:title" content="Aircon Service FAQs StringsSG"/> 
        <meta name="twitter:description" content="Frequently asked questions related to aircon servicing in Singapore"/>
        <link rel="icon" href="/favicon.ico" />
        {/* Same FAQs as the hub (acSingaporeFaqs), which already emits them as
            FAQPage - so this page defers to the hub and emits no FAQ schema of
            its own. The hand-written FAQPage that used to sit here described
            service-provider sign-up, which is not on this page at all. */}
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore" />
      </Head>
        <div className='max-w-5xl mx-auto'>  
            <Faq 
              questionsAnswers={acSingaporeFaqs}
              title="Aircon Service FAQs"
              jsonLd={false}
            /> 
        </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}